import React, { useEffect, useRef, useState } from "react";
import HtmlHead from "../components/html-head/HtmlHead";
import { Link, useNavigate } from "react-router-dom";
import { LuMoveLeft } from "react-icons/lu";
import MamaDaiIntroduction from "./components/MamaDaiIntroduction";
import { IoMenu } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import axios from "axios";
import { ApiService } from "../helpers/services/apiSrevice";
import AlertService from "../helpers/services/alertService";

const DEFAULT_GAME_BUTTON_TEXT = "Open game";

const getGameButtonLabel = (item) => {
    const normalizedLabel = typeof item?.gameText === "string" ? item.gameText.trim() : "";
    return normalizedLabel || DEFAULT_GAME_BUTTON_TEXT;
};

const MamaDai = ({ courseData }) => {

    const { user } = useSelector(state => state.user);
    const navigate = useNavigate();
    const title = courseData.title || "";
    const description = "";
    const [isShowIntroduction, setIsShowIntroduction] = useState(true);
    const [isShowLeftMenu, setIsShowLeftMenu] = useState(false);
    const [activeDay, setActiveDay] = useState(null);
    const [isDisabledFields, setIsDisabledFields] = useState(false);

    const scrollTimerRef = useRef(null);

    const scrollToTop = () => {
        clearTimeout(scrollTimerRef.current);
        scrollTimerRef.current = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 300);
    };

    useEffect(() => () => clearTimeout(scrollTimerRef.current), []);

    useEffect(() => {
        if (!user) {
            navigate("/");
        }
    }, [user])

    useEffect(() => {
        if (!courseData) return;
        const { introduction, courseContents } = courseData;
        if (introduction) {
            setIsShowIntroduction(true);
        } else if (Array.isArray(courseContents) && courseContents.length > 0) {
            setActiveDay(courseContents[0]);
        }
    }, [courseData]);

    const downloadZip = (endpoint) => {
        if (!endpoint) { return false; }
        setIsDisabledFields(true);
        ApiService.downloadZip(endpoint).then(response => {
            if (response && response.data && typeof response.data === "string") {
                window.open(response.data, "_blank");
            }
        }).catch(error => {
            AlertService.alert("warning", error);
        }).finally(() => {
            setIsDisabledFields(false);
        })
    };

    if (!courseData) { return false };

    return <div className="mama-dai">
        <HtmlHead title={title} description={description} />
        <div className="d-flex d-lg-none mobile-menu px-3 mt-3 justify-content-between">
            <div className="menu-icon" onClick={() => setIsShowLeftMenu(true)}>
                <IoMenu className="text-white" />
            </div>
        </div>
        <div className="d-flex">
            {
                isShowLeftMenu ?
                    <div className="layer d-block d-lg-none" onClick={() => setIsShowLeftMenu(false)}></div>
                    : null
            }
            <div className={`left-menu text-white ${isShowLeftMenu ? "open open-animation" : ""}`}>
                <div className="">
                    <IoClose className="text-white close-icon d-block d-lg-none" size={30} onClick={() => setIsShowLeftMenu(false)} />
                    <div className="left-menu-header">
                        <Link to="/" className="header-button d-flex gap-2 align-items-center border-1 border-white left-menu-top-button">
                            <LuMoveLeft />
                            <span>на главную</span>
                        </Link>
                        <Link to="/account" className="header-button mt-2 d-flex text-nowrap gap-2 align-items-center border-1 border-white left-menu-top-button">
                            <LuMoveLeft />
                            <span>личный кабинет</span>
                        </Link>
                        <div className="mt-4 mb-3">
                            <p className="sub-title" style={{ textTransform: "capitalize" }}>
                                {courseData.title}
                            </p>
                        </div>
                    </div>
                    {
                        courseData.introduction ?
                            <span
                                className={`introduction ${isShowIntroduction ? "active-item" : ""}`}
                                onClick={() => {
                                    setIsShowLeftMenu(false);
                                    setIsShowIntroduction(!isShowIntroduction);
                                    setActiveDay(null);
                                    if (!isShowIntroduction) {
                                        scrollToTop();
                                    }
                                }}
                            >
                                введение
                            </span>
                            : null
                    }
                </div>
                <div>
                    {
                        courseData.courseContents && courseData.courseContents.length ?
                            courseData.courseContents.map((item, index) => {
                                return <div key={index} className="day" onClick={() => {
                                    setActiveDay(item);
                                    setIsShowLeftMenu(false);
                                    setIsShowIntroduction(false);
                                    scrollToTop();
                                }}>
                                    <span className={`${activeDay?.id === item.id ? "active-item" : ""}`}>{item.title}</span>
                                </div>
                            })
                            : null
                    }
                </div>
            </div>

            <div className="right-block">
                {
                    !isShowIntroduction && !activeDay ?
                        <div className="home not-selected-block">
                            <div className="d-flex flex-column align-items-center px-4">
                                <p className="text-white text-center description">Чтобы начать заниматься, выберите в меню нужный Вам пункт.</p>
                            </div>
                        </div>
                        : null
                }
                {
                    isShowIntroduction && !activeDay ?
                        <MamaDaiIntroduction courseData={courseData} />
                        : null
                }
                <Container className="p-0">
                    {
                        activeDay ?
                            <div className="day-content">
                                <div className="day-block radius-50 mb-3 mt-5">
                                    <h3 className="title">{activeDay.title}</h3>
                                    {
                                        activeDay.courseSubcontents && activeDay.courseSubcontents.length ?
                                            activeDay.courseSubcontents.map((item, index) => {
                                                if (!item.isHomework) {
                                                    return <div key={index} className="description text-white" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                                }
                                            })
                                            : null
                                    }
                                </div>
                                {
                                    activeDay.courseSubcontents && activeDay.courseSubcontents.length
                                        ? activeDay.courseSubcontents.map((item, index) => {
                                            if (!item.isHomework) {
                                                return (
                                                    <React.Fragment key={index}>
                                                        {item.gamePath && (
                                                            <div className="mb-3 mb-lg-3">
                                                                <button className="radius-50" onClick={() => window.open(item.gamePath, "_blank")}>
                                                                    {getGameButtonLabel(item)}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {item.videoPath && (
                                                            <div className="mb-3 mb-lg-3">
                                                                {/* <button className="radius-50" onClick={() => window.open(item.videoPath, "_blank")} disabled={isDisabledFields}>
                                                                    {item.videoText}
                                                                </button> */}
                                                                <button className="radius-50" onClick={() => downloadZip(item.videoPath)} disabled={isDisabledFields}>
                                                                    {item.videoText}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {item.zipFilePath && (
                                                            <div className="mb-3 mb-lg-3">
                                                                {/* <button className="radius-50" onClick={() => window.open(item.zipFilePath, "_blank")}>
                                                                    {item.fileText}
                                                                </button> */}
                                                                <button className="radius-50" onClick={() => downloadZip(item.zipFilePath)} disabled={isDisabledFields}>
                                                                    {item.fileText}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            }
                                            return null;
                                        })
                                        : null
                                }
                                {
                                    activeDay.courseSubcontents && activeDay.courseSubcontents.find(el => el.isHomework) ?
                                        <div className="homework-block radius-50 mb-4">
                                            {
                                                activeDay.courseSubcontents.map((item, index) => {
                                                    if (item.isHomework) {
                                                        return <div key={index}>
                                                            <h3 className="title">{item.title || ""}</h3>
                                                            <div key={index} className="description text-white" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                                        </div>
                                                    }
                                                })
                                            }
                                        </div>
                                        : null
                                }

                                {
                                    activeDay.courseSubcontents && activeDay.courseSubcontents.length
                                        ? activeDay.courseSubcontents.map((item, index) => {
                                            if (item.isHomework) {
                                                return (
                                                    <React.Fragment key={index}>
                                                        {item.gamePath && (
                                                            <div className="mb-3 mb-lg-3">
                                                                <button className="radius-50" onClick={() => window.open(item.gamePath, "_blank")}>
                                                                    {getGameButtonLabel(item)}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {item.videoPath && (
                                                            <div className="mb-3 mb-lg-3">
                                                                {/* <button className="radius-50" onClick={() => window.open(item.videoPath, "_blank")} disabled={isDisabledFields}>
                                                                    {item.videoText}
                                                                </button> */}
                                                                <button className="radius-50" onClick={() => downloadZip(item.videoPath)} disabled={isDisabledFields}>
                                                                    {item.videoText}
                                                                </button>
                                                            </div>
                                                        )}
                                                        {item.zipFilePath && (
                                                            <div className="mb-3 mb-lg-3">
                                                                {/* <button className="radius-50" onClick={() => window.open(item.zipFilePath, "_blank")} disabled={isDisabledFields}>
                                                                    {item.fileText}
                                                                </button> */}
                                                                <button className="radius-50" onClick={() => downloadZip(item.zipFilePath)} disabled={isDisabledFields}>
                                                                    {item.fileText}
                                                                </button>
                                                            </div>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            }
                                            return null;
                                        })
                                        : null
                                }

                            </div>
                            : null
                    }
                </Container>
            </div>
        </div>
    </div>
}



export default MamaDai
